<template>
  <div class="main-container-computer">
    <div class="login-bg">
      <img src="@/assets/images/logo.png" class="login-logo" />
      <div class="login">
        <div v-show="status === 'login'">
          <div class="login-inner">
            <form
              autocomplete="off"
              method="post"
              data-success="@{login.redirect()}"
            >
              <div class="login-item mgb20 user-phone">
                <input
                  v-model="phone"
                  type="text"
                  class="clearError"
                  placeholder="请输入手机号码"
                  maxlength="11"
                  @keyup.enter="goLogin"
                  @input="inputPhone"
                />
              </div>

              <div v-if="!isPasswordLogin" class="login-item mgb20 safe-code">
                <input
                  v-model="loginCode"
                  type="text"
                  class="clearError"
                  placeholder="请输入6位验证码"
                  maxlength="6"
                  @keyup.enter="goLogin"
                />
                <div class="login-code-btn" :class="loginSendCodeTimeInfo.time ? 'disable-btn' : ''" @click="loginSendCode">
                  <span v-show="!loginSendCodeTimeInfo.time">获取验证码</span>
                  <span v-show="loginSendCodeTimeInfo.time">{{ loginSendCodeTimeInfo.time }}</span>
                </div>
              </div>

              <div v-if="isPasswordLogin">
                <div class="login-item mgb20 user-pwd">
                  <input
                    v-model="password"
                    type="password"
                    class="clearError"
                    placeholder="请输入密码"
                    maxlength="24"
                    @keyup.enter="goLogin"
                  />
                </div>

                <div class="clearfix mgb20">
                  <div class="login-item code safe-code fl">
                    <input
                      v-model="code"
                      type="text"
                      class="clearError"
                      placeholder="请输入4位数字验证码"
                      maxlength="4"
                      @keyup.enter="goLogin"
                      @input="inputCode"
                    />
                  </div>
                  <div class="code-img fl mgl5">
                    <img
                      :src="codeImg"
                      class="p-code-image"
                      alt=""
                      @click="refreshCode"
                    />
                  </div>
                </div>
              </div>
              <div class="checkbox-group clearfix mgb20">
                <label v-show="isPasswordLogin" class="fl"><input v-model="savePassword" type="checkbox" />记住密码</label>
                <div class="login-type-change-text" @click="changeLoginType">{{ loginTypeChangeText }}</div>
              </div>
              <div>
                <div v-if="!isLoading" class="login-btn" @click="goLogin">登录</div>
                <div v-else class="login-btn login-btn-loading">登录中</div>
              </div>
            </form>
          </div>
          <div class="chrome-text">
            <span style="display: inline-block;">为了获得更好的体验，请使用谷歌(chrome)浏览器</span>
            <a style="display: inline-block;text-decoration:underline; color: rgba(153, 153, 153, 1);" href="https://www.google.cn/chrome/">下载谷歌浏览器</a>
          </div>
        </div>
        <div v-show="status === 'forget'">
          <div class="login-inner">
            <form
              autocomplete="off"
            >
              <div class="login-item mgb20 user-phone">
                <input
                  v-model="forgetpwdForm.phone"
                  type="text"
                  class="clearError"
                  placeholder="请输入手机号码"
                  maxlength="11"
                  @keyup.enter="resetPwd"
                  @input="inputPwdPhone"
                />
              </div>

              <div class="clearfix mgb20">
                <div class="login-item safe-code fl">
                  <input
                    v-model="forgetpwdForm.code"
                    type="text"
                    class="clearError forget-safe-code-input"
                    placeholder="请输入6位验证码"
                    maxlength="6"
                    @keyup.enter="resetPwd"
                    @input="inputPwdCode"
                  />
                  <div class="ml5 fl mgl5 login-code-btn" :class="passwordSendCodeTimeInfo.time ? 'disable-btn' : ''" @click="sendCode">
                    <span v-show="!passwordSendCodeTimeInfo.time">获取验证码</span>
                    <span v-show="passwordSendCodeTimeInfo.time">{{ passwordSendCodeTimeInfo.time }}</span>
                  </div>
                </div>
              </div>

              <div class="login-item mgb20 user-pwd">
                <input
                  v-model="forgetpwdForm.password"
                  type="password"
                  class="clearError"
                  placeholder="请输入重置密码"
                  maxlength="20"
                  @keyup.enter="resetPwd"
                />
              </div>

              <div class="login-item mgb20 user-pwd">
                <input
                  v-model="forgetpwdForm.againPassword"
                  type="password"
                  class="clearError"
                  placeholder="再次确认重置密码"
                  maxlength="20"
                  @keyup.enter="resetPwd"
                />
              </div>

              <div>
                <div v-if="!isLoading" class="login-btn" @click="resetPwd">确认</div>
                <div v-else class="login-btn login-btn-loading">确认中</div>
              </div>
              <div class="checkbox-group clearfix mgb20">
                <a class="fr login-link" @click="gotoLogin">登录</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <img class="bg_img_left" src="@/assets/images/login/bg-left.png" />
  </div>
</template>

<script>
import mixin from './mixin.js'
export default {
  mixins: [mixin]
}
</script>

<style lang="scss">
.main-container-computer {
  .login-bg {
    position: absolute;
    min-width: 1366px;
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/images/login/login-newbg.png');
    background-size: 73% 100%;
    background-position: right center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    z-index: 2;
    .login-logo {
      position: absolute;
      top: 0.6rem;
      left: 0.6rem;
      height: 0.6rem;
      cursor: pointer;
    }
    .login {
      width: 3.4rem;
      z-index: 9;
      margin: 0 0 0 2.11rem;
      position: relative;
      .login-inner {
        width: 100%;
        margin: 0;
        .user-phone::before, .user-pwd::before, .safe-code::before {
          width: 0.17rem;
          height: 0.28rem;
          content: "";
          background-repeat: no-repeat;
          background-size: 0.17rem 0.19rem;
          position: absolute;
          top: 0.1rem;
          bottom: 0;
          left: 0.1rem;
        }
        .user-phone::before {
          background-image: url('~@/assets/images/login/icon-usr.png');
        }
        .user-pwd::before {
          background-image: url('~@/assets/images/login/icon-pwd.png');
        }
        .safe-code::before {
          background-image: url('~@/assets/images/login/safepc.png');
        }
      }
      .chrome-text {
        margin-top: 0.1rem;
        font-weight: 500;
        color: #015478;
        font-size: 0.14rem;
        line-height: 0.26rem;
        text-align: center;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  .bg_img_left {
    width: 100%;
    height: 4.24rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .login-item input {
    font-family: MicrosoftYaHei;
    outline: none;
    -webkit-appearance: none;
    border-radius: 0;
    border: none;
    background-color: #fff !important;
    border-bottom: 0.012rem solid rgba(151, 151, 151, 0.4);
    width: 100%;
    height: 0.42rem;
    line-height: 0.42rem;
    font-size: 0.14rem;
    vertical-align: bottom;
    padding-left: 0.36rem;
    padding-right: 1rem;
    box-sizing: border-box;
  }
  .login-item .forget-safe-code-input {
    padding-right: 0;
  }

  .chrome-text {
    margin-top: 0.1rem;
    font-weight: 500;
    color: #015478;
    font-size:0.14rem;
    line-height: 0.26rem;
    text-align: center;
    color: rgba(153, 153, 153, 1);
  }
  .mgb20 {
    margin-bottom: 0.2rem;
  }

  .checkbox-group, .radio-group {
    padding-left: 0.1rem;
    padding-top: 0.05rem;
  }
  .code-img {
    border: none;
  }
  .code-img img {
    height: 0.42rem;
    width: 1.3rem;
  }
  .login-btn {
    height: 0.43rem;
    line-height: 0.21rem;
    text-align: center;
    border-radius: 0.08rem;
    font-size: 0.16rem;
    padding: 0.1rem 0;
    border-radius: 0.08rem;
    width: 100%;
    border: none;
    background-color: #257efe;
    color: #fff;
    cursor: pointer;
    box-shadow: 0.01rem 0.02rem 0.08rem #bfd0e9
  }
  .login-btn-loading {
    cursor: not-allowed;
  }

  .disable-btn {
    color: #00000040;
    background: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    box-shadow: none;
    cursor: not-allowed;
  }

  .login-item.code {
    width: calc(100% - 1.3rem);
    input {
      padding-right: 0.36rem;
    }
  }
  .login-forgetlink {
    display: block;
    padding-top: 3px;
  }
  .login-type-change-text {
    float: right;
    line-height: 20px;
    cursor: pointer;
  }
  .checkbox-group label, .radio-group label {
    line-height: 20px;
    margin-right: 20px;
    cursor: pointer;
    *zoom: 1;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  a {
    text-decoration: none;
    color: #000;
  }
  .checkbox-group input, .radio-group input, input.checkbox, input.radio {
    width: auto;
    box-shadow: none;
    background: 0 0;
    margin: 0 2px 0 0;
    vertical-align: -2px;
    *vertical-align: middle;
    cursor: pointer;
  }
  .login-forgetlink {
    display: block;
    padding-top: 3px;
  }
  .login-link {
    display: block;
    padding-top: 3px;
  }
  .clearfix:after {
    display: block;
    content: " ";
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .login .checkbox-group {
    display: block;
    line-height: 100%;
    font-size: 0.14rem;
  }
  .checkbox-group, .radio-group {
    padding-left: 0.1rem;
    padding-top: 10px;
  }
  .login-item {
    position: relative;
    width: 100%;
    border: none;
    background: none;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .login-code-btn, .forget-pwd-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    text-align: center;
    color: #257efe;
    font-size: 14px;
    line-height: 42px;
    cursor: pointer;
  }
  .login-code-btn.disable-btn {
    color: #d9d9d9;
    background: transparent;
    border-color: transparent
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: color 99999s ease-out, background-color 99999s ease-out;
  }
}
</style>
